<template>
  <div class="container">

    <heading-one class="-margin-md">ご契約手続きの完了</heading-one>

    <notice-box class="-success -margin-md">
      <notice-header>
        <h2 class="heading">ご契約が成立いたしました。</h2>
      </notice-header>

      <notice-box class="-bgwhite">
        <notice-body class="_mb-md-30 _mb-sm-25">ご契約内容のご案内はこちらからご確認ください。</notice-body>
        <list-group class="-link">
          <list-item href='#' class="-link" @click.prevent="showPdf()">
            <element-box>
              <heading-icon class="-left _mb-0">
                ご契約内容のご案内<icon-box src="pdf" class="-xs _ml-5"></icon-box>
              </heading-icon>
            </element-box>
          </list-item>
        </list-group>
      </notice-box>
    </notice-box>

    <p class="txt02">以下より会員さま専用サイトへアクセスしお取引ください。<br>
      今後ともau PAY スマートローンをお引き立てのほどよろしくお願い申しあげます。</p>

    <btngroup-single class="-margin-lg">
      <btn-main class="-normal" routerName="mb001">
        お借り入れはこちら
      </btn-main>
    </btngroup-single>

  </div><!-- container -->
</template>

<script>
import { getUserSessionLambdaInvoke, apiGetContractPdf } from '../utils/LambdaHelper'
import HeadingOne from '../components/heading/HeadingOne'
import NoticeBox from '../components/box/NoticeBox'
import NoticeHeader from '../components/box/NoticeHeader'
import ElementBox from '../components/elements/element-box'
import HeadingIcon from '../components/heading/HeadingIcon'
import IconBox from '../components/icons/icon-box'
import NoticeBody from '../components/box/NoticeBody'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'

export default {
  name: 'En-013',
  metaInfo: {
    title: 'ご契約締結の完了',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,審査,審査結果,契約'}
    ]
  },
  components: {
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    NoticeBody,
    IconBox,
    HeadingIcon,
    ElementBox,
    NoticeHeader,
    NoticeBox,
    HeadingOne
  },
  data () {
    return {
      userSessionData: {
        user_session: '',
        state: ''
      }
    }
  },
  mounted () {
    getUserSessionLambdaInvoke().then(res => {
      for (let key in res) {
        if (this.userSessionData.hasOwnProperty(key)) {
          this.userSessionData[key] = res[key]
        }
      }
    }).catch(error => {
      this.goToErrorPage(error)
    })
  },
  methods: {
    showPdf () {
      const userSession = this.userSessionData.user_session
      const state = this.userSessionData.state

      apiGetContractPdf({user_session: userSession, state: state}).then(res => {
        if (window.navigator.msSaveBlob) {
          // IEやEdgeの場合、Blob URL Schemeへと変換しなくともダウンロードできる
          window.open(`${process.env.GET_CONTRACT_PDF}?user_session=${userSession}&state=${state}`, '_blank')
        } else {
          // BlobをBlob URL Schemeへ変換してリンクタグへ埋め込む
          window.open(`${process.env.GET_CONTRACT_PDF}?user_session=${userSession}&state=${state}`, '_blank')
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
  .txt02 {
    @include mq-up(md) {
      text-align: center;
    }
  }

  .no-pdf {
    color: red;

  }
</style>



// WEBPACK FOOTER //
// src/pages/En013.vue